// src/i18n/index.ts
/**
 * CourseyVoyage 多國語字串表
 * 每個語言獨立定義於各自檔案
 *
 * - zh-TW.ts: 繁體中文
 * - en.ts: English
 * - ja.ts: 日本語
 * - types.ts: 型別、常數、工具函式
 */
import type { Locale, Strings } from './types';
import {
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  WEEKDAY_KEYS,
  WEEKDAY_KEYS_WEEK_VIEW,
  interpolate,
} from './constants';
import { zhTW } from './zh-TW';
import { en } from './en';
import { ja } from './ja';

// 型別 re-export
export type { Locale, Strings };
export type { CourseTypeKey, PaymentMethodKey } from './types';

// 執行期常數／工具
export {
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  WEEKDAY_KEYS,
  WEEKDAY_KEYS_WEEK_VIEW,
  interpolate,
};

// 每個語言的字串表
export const strings: Record<Locale, Strings> = {
  'zh-TW': zhTW,
  en,
  ja,
};